export const parseNumericValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return 0;
  }

  const normalized = String(value).replace(/,/g, "").trim();
  if (normalized === "") {
    return 0;
  }

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const formatNumberWithCommas = (value) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const normalized = String(value).replace(/,/g, "").trim();
  if (normalized === "") {
    return "";
  }

  const sign = normalized.startsWith("-") ? "-" : "";
  const unsigned = sign ? normalized.slice(1) : normalized;
  const [integerPart, decimalPart] = unsigned.split(".");
  const formattedInteger = (integerPart || "0").replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  );

  return decimalPart !== undefined
    ? `${sign}${formattedInteger}.${decimalPart}`
    : `${sign}${formattedInteger}`;
};

const currencyValueKeys = new Set([
  "amount",
  "mmk_amount",
  "thb_amount",
  "minimum_total_amount",
  "promotion_amount",
  "retail_price",
  "wholesale_price",
  "price",
  "total",
  "total_amount",
  "sub_total",
  "sub_total_mmk",
  "sub_total_thb",
  "total_mmk",
  "total_thb",
  "paid_amount",
  "paid_amount_mmk",
  "paid_amount_thb",
  "change",
  "change_mmk",
  "change_thb",
  "discount",
  "discount_in_mmk",
  "discount_in_thb",
  "tax_amount",
  "tax_amount_mmk",
  "tax_amount_thb",
  "exchange_rate",
  "reverse_exchange_rate",
  "dailyWholesale",
  "dailyRetailsale",
  "promotionAmount",
  "taxAmount",
  "totalInMMK",
  "totalInTHB",
  "paidAmountInMMK",
  "paidAmountInTHB",
  "changeInMMK",
  "changeInTHB",
  "discountInMMK",
  "discountInTHB",
  "promotionAmountInMMK",
  "promotionAmountInTHB",
  "taxAmountInMMK",
  "taxAmountInTHB",
  "subTotal",
  "subTotalMMK",
  "subTotalTHB",
  "paidAmount",
  "advancedInMMK",
  "advancedInTHB",
]);

export const isCurrencyLikeKey = (key = "") => currencyValueKeys.has(key);

export const formatCurrencyByKey = (key, value) =>
  isCurrencyLikeKey(key) ? formatNumberWithCommas(value) : value;

export const formatReceiptCurrency = (value, currency) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const parsed = parseNumericValue(value);
  const normalizedCurrency = String(currency || "").toUpperCase();
  const maxFractionDigits =
    normalizedCurrency === "BAHT" || normalizedCurrency === "THB" ? 6 : 2;
  const hasFraction = Math.abs(parsed % 1) > Number.EPSILON;

  return parsed.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: hasFraction ? maxFractionDigits : 0,
  });
};
